module.exports = {
	"currencyType": "Tous les prix sont en __currencyType__",
	"description": "Avec l'abonnement de base vous pouvez publier des encans et avoir votre entreprise répertoriée dans notre annuaire d'encanteurs, vous êtes cependant limité par le nombre de lots que vous pouvez publier et le nombre de photos que vous pouvez mettre par lot. Vous pouvez enlever ces limites avec un compte premium.",
	"free": "Gratuit",
	"header": "Tarification de l'abonnement",
	"headerSmall": "Abonnement d'encanteur",
	"basic": {
		"description": "Vous pouvez publier vos encans et avoir votre entreprise répertoriée dans l'annuaire.",
		"item1": "Encans et entreprise affichés dans l'annuaire.",
		"item2": "Jusqu'à __maxLots__ lots par encan.",
		"item3": "Limite de __maxPictures__ photos par lot."
	},
	"premium": {
		"description": "Un abonnement premium permet de publier plus de lots par encan et d'afficher plus de photos par lot.",
		"item1": "Affiché avec les entreprises et encans en primeur.",
		"item2": "Jusqu'à __maxLots__ lots par encan.",
		"item3": "Limite de __maxPictures__ photos par lot."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/pricing.json5
// module id = 2007
// module chunks = 6